<div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="clearfix text-center">
            <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
              <span class="sr-only">Loading...</span>
            </div>
            <h4 class="pt-3">Redirecting...</h4>
            <p class="text-muted">Please wait while we redirect you to the appropriate page.</p>
          </div>
        </div>
      </div>
    </div>
  </div>